import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fromView: '',
  invoicesOrSupplier: '',
  individualName: ''
};

export const fillOutInvoicesSlice = createSlice({
  name: 'fillOutInvoices',
  initialState,
  reducers: {
    setFillOutInvoices: (state, action) => {
      for (const key of Object.keys(action.payload)) {
        state[key] = action.payload[key];
      }
    }
  }
});

export const { setFillOutInvoices } = fillOutInvoicesSlice.actions;
export default fillOutInvoicesSlice.reducer;
